import React, {useState} from "react";
import "./index.css";
import { Link } from "react-router-dom";
import createInstance from "../../../api/axiosinstance";
import { toast } from "react-toastify";


const SupportForm = () => {
  const aiDishaApi = createInstance("DISHA")

    const [formData, setFormData] = useState({
      name: "",
      phone_no:"",
      email: "",
      subject: "",
      description: "",
    });


const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    aiDishaApi.post("/post_complaint",formData)
    .then((response)=>{
      console.log("Form Submitted", response.data);
      toast.success("Your request has been submitted successfully!")
      setFormData({ name: "",phone_no:"" ,email: "", subject: "", description: "" });
    })
    .catch((error)=>{
      console.error(error)
      toast.error(error)
    })
    
    
  };

  return (
    <div className="form-container">
        <Link className="home-btn">HOME</Link>
      <h2 className="form-title">How Can We Help?</h2>
      <form onSubmit={handleSubmit} className="support-form">
        <div className="form-group">
          <label>Name</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Phone.No</label>
          <input
            type="text"
            name="phone_no"
            value={formData.phone_no}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Email</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Subject</label>
          <input
            type="text"
            name="subject"
            value={formData.subject}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Description</label>
          <textarea
            name="description"
            rows="4"
            value={formData.description}
            onChange={handleChange}
            required
          ></textarea>
        </div>

        <button type="submit" className="submit-button">Submit</button>
      </form>
    </div>
  );
};

export default SupportForm;